import * as v from 'valibot';
import {QEPNotificationLocation as QEPNotificationLocationFEType, QEPNotificationStatus as QEPNotificationStatusFEType, QEPNotificationType as QEPNotificationTypeFEType} from '@qep/types/src';

export const NotificationBuilderResponseSchema = v.pipe(
  v.string(),
  v.regex(/^<div class="custom-noty"/i, 'Returned value is not an html string'),
);

export const QEPNotificationTypeSchema = v.enum(QEPNotificationTypeFEType, 'Invalid notification type');

export const QEPNotificationStatusSchema = v.enum(QEPNotificationStatusFEType, 'Invalid notification status');

export const QEPNotificationLocationSchema = v.enum(QEPNotificationLocationFEType, 'Invalid notification location');

export const QEPNotificationPayloadSchema = v.object({
  id: v.optional(v.nullable(v.string())),
  title: v.string(),
  shortDescription: v.optional(v.nullable(v.string())),
  longDescription: v.optional(v.nullable(v.string())),
  type: QEPNotificationTypeSchema,
  status: v.optional(v.nullable(QEPNotificationStatusSchema)),
  timestamp: v.optional(v.nullable(v.string())),
  payload: v.optional(v.nullable(v.any())), // Revisit
  location: v.optional(v.nullable(QEPNotificationLocationSchema)),
});
export type QEPNotificationPayload = v.InferOutput<typeof QEPNotificationPayloadSchema>;

export const SendNotificationNotySchema = v.object({
  type: v.optional(v.nullable(v.picklist(['alert', 'success', 'warning', 'error', 'info', 'information']))),
  layout: v.optional(v.nullable(v.picklist([
    'top',
    'topLeft',
    'topCenter',
    'topRight',
    'center',
    'centerLeft',
    'centerRight',
    'bottom',
    'bottomLeft',
    'bottomCenter',
    'bottomRight',
  ]))),
  theme: v.optional(v.nullable(v.picklist([
    'mint',
    'sunset',
    'relax',
    'metroui',
    'bootstrap-v3',
    'bootstrap-v4',
    'semanticui',
    'nest',
  ]))),
  text: v.optional(v.nullable(v.string())),
  timeout: v.optional(v.nullable(v.union([v.number(), v.literal(false)]))),
  progressBar: v.optional(v.nullable(v.boolean())),
  closeWith: v.optional(v.nullable(v.array(v.picklist(['click', 'button'])))), // Revisit
  animation: v.optional(v.nullable(v.object({
    open: v.optional(v.nullable(v.union([v.string(), v.function()]))),
    close: v.optional(v.nullable(v.union([v.string(), v.function()]))),
  }))),
  id: v.optional(v.nullable(v.union([v.string(), v.literal(false)]))),
  force: v.optional(v.nullable(v.boolean())),
  killer: v.optional(v.nullable(v.union([v.string(), v.boolean()]))),
  queue: v.optional(v.nullable(v.string())),
  container: v.optional(v.nullable(v.union([v.string(), v.literal(false)]))),
  buttons: v.optional(v.nullable(v.array(v.object({
    text: v.string(),
    classNames: v.string(),
    cb: v.function(),
    attributes: v.any(),
  })))),
  callbacks: v.optional(v.nullable(v.object({
    beforeShow: v.optional(v.nullable(v.function())),
    onShow: v.optional(v.nullable(v.function())),
    afterShow: v.optional(v.nullable(v.function())),
    onClose: v.optional(v.nullable(v.function())),
    afterClose: v.optional(v.nullable(v.function())),
    onHover: v.optional(v.nullable(v.function())),
    onTemplate: v.optional(v.nullable(v.function())),
  }))),
  sounds: v.optional(v.nullable(v.object({
    sources: v.optional(v.nullable(v.array(v.string()))),
    volume: v.optional(v.nullable(v.number())),
    conditions: v.optional(v.nullable(v.array(v.string()))),
  }))),
  docTitle: v.optional(v.nullable(v.object({
    conditions: v.optional(v.nullable(v.array(v.string()))),
  }))),
  modal: v.optional(v.nullable(v.boolean())),
});

export const SendNotificationCustomNotificationSchema = v.object({
  type: QEPNotificationTypeSchema,
  title: v.string(),
  shortDescription: v.string(),
  location: QEPNotificationLocationSchema,
});

export const SendNotificationResponseSchema = v.union([SendNotificationNotySchema, SendNotificationCustomNotificationSchema]);
export type SendNotificationResponse = v.InferOutput<typeof SendNotificationResponseSchema>;
